import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";
import { Field } from "formik";

import FormikSemanticCheckbox from "../../forms/formik/FormikSemanticCheckbox.jsx";
import SegmentMessage from "../../forms/messages/SegmentMessage.jsx";

import { PANEL_STATES } from "../../../state/reducers/projectWizard/projectWizardConstants.js";

import { selectDefaultRequiresUserVerification } from "../../../state/reducers/projectWizard/projectWizardSelectors.js";
import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class UseOTPPanel extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    view: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    selected: PropTypes.object,

    defaultRequiresUserVerification: PropTypes.bool,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    name: "requiresUserVerification",
    showValidity: false,
    copyKey: "project_wizard.use_otp_panel"
  };

  // -- RENDER --//

  renderActive = () => {
    const { name, apiErrors, defaultRequiresUserVerification, copyKey, copy } =
      this.props;

    return (
      <Fragment>
        <Header as="h3" attached="top" block>
          {copy(`${copyKey}.title`)}
        </Header>
        <Segment
          clearing={true}
          attached
          disabled={defaultRequiresUserVerification === undefined}
        >
          <p>{copy(`${copyKey}.body`)}</p>

          <Field
            name={name}
            label={copy(`${copyKey}.dropdown_label`)}
            placeholder={copy(`${copyKey}.dropdown_placeholder`)}
            required={false}
            disabled={defaultRequiresUserVerification === undefined}
            apiErrors={apiErrors}
            component={FormikSemanticCheckbox}
          />
        </Segment>
      </Fragment>
    );
  };

  renderSet = () => {
    const { selected, copyKey, copy } = this.props;

    if (selected && selected.readonly) {
      return (
        <SegmentMessage
          title={copy(`${copyKey}.messages.already_set_readonly.title`)}
          message={copy(`${copyKey}.messages.already_set_readonly.message`)}
          negative={true}
          style={{ marginTop: "2em" }}
        />
      );
    }

    return null;

    // currently not needed but may be useful once multiregion/multiprovider is in place
    // const { selected, copyKey, copy } = this.props;
    // return (
    //   <Fragment>
    //     <Header as="h3" attached="top" block>
    //       {copy(`${copyKey}.title`)}
    //     </Header>
    //     <Segment clearing={true} attached>
    //       <p>{copy(`${copyKey}.already_set_body`)}</p>
    //       <p>
    //         <strong>{`${selected.name}`}</strong>
    //       </p>
    //     </Segment>
    //   </Fragment>
    // );
  };

  renderInactive = () => {
    return null;
  };

  render() {
    const { view, selected, defaultRequiresUserVerification } = this.props;

    switch (view) {
      case PANEL_STATES.ACTIVE:
        if (selected) {
          return this.renderSet();
        }

        return this.renderActive();
      default:
        return this.renderInactive();
    }
  }
}

const mapStateToProps = state => ({
  defaultRequiresUserVerification: selectDefaultRequiresUserVerification(state),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(UseOTPPanel);
